import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import dateFormat from 'dateformat'
import { toast } from 'react-toastify'
import { fetchDocList } from '../../../utilities/API/document/documentAPI'
import moment from "moment";

export const fetchAppDocList = createAsyncThunk(
    'appDocList', fetchDocList
)


const initialState = {
    docList:[],
    corrList:{}
}

const documentListSlice = createSlice({
    name: 'docList',
    initialState,
    reducers: {
        resetApplicationsDocLists: (state) => {
            state.corrList={};
            state.docList=[];
            // toast.success("Applictions reseted Successfully")
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAppDocList.pending, (state, action) => {
                // toast.warn("applications list pending")
            })
            .addCase(fetchAppDocList.fulfilled, (state, action) => {
                let CorARR = {};
                let dataOfDate=typeof action.payload?.res?.UploadDocuments?.pxResults != 'undefined' ? action.payload?.res?.UploadDocuments?.pxResults : [] 
                let updatedData=[]
               if(dataOfDate.length != 0){
                updatedData = dataOfDate.map(item => ({
                    ...item,
                    DocumentReceptionDate: moment(item.DocumentReceptionDate).format('L')
                }));
               }
             
                state.docList = updatedData
                action.payload?.res?.CorrList?.pxResults && action.payload?.res?.CorrList?.pxResults.length > 0 && action.payload?.res?.CorrList?.pxResults.map(data=>{
                let FileName = data.FileName;
                if(CorARR[FileName] != undefined){
                 if(CorARR[FileName].ARR[0].PreferredLanguage != data.PreferredLanguage && CorARR[FileName].ARR.length < 2){ 
                  CorARR[FileName].ARR.push(data)
                 }
                }else{
                  let arr = []
                  arr.push(data)
                  Object.assign(CorARR,{
                    [FileName]: {
                      ARR:arr
                    }
                  })
                }
                })
                state.corrList = CorARR
               
            })
            .addCase(fetchAppDocList.rejected, (state, action) => {
                // toast.error(action.error.message)
            })




    },
})

export const { resetApplicationsDocLists } = documentListSlice.actions

export default documentListSlice.reducer